import React from 'react';
import { FaHistory } from 'react-icons/fa';

const ago = (ts) => {
  const mins = Math.round((Date.now() - ts) / 60000);
  if (mins < 1) return 'hace un momento';
  if (mins < 60) return `hace ${mins} min`;
  const hrs = Math.round(mins / 60);
  return hrs < 24 ? `hace ${hrs} h` : `hace ${Math.round(hrs / 24)} d`;
};

/** Aviso de borrador recuperado (ver useDraft). */
export default function DraftBanner({ restoredAt, onDiscard }) {
  if (!restoredAt) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-3 rounded-xl px-4 py-3 text-sm"
      style={{ backgroundColor: 'rgba(0,194,255,0.07)', border: '1px solid rgba(0,194,255,0.25)', color: '#C9E9F5' }}
    >
      <FaHistory style={{ color: '#00C2FF' }} aria-hidden />
      <span className="flex-1 min-w-[200px]">
        Recuperamos los cambios que no habías guardado ({ago(restoredAt)}). Revísalos y guarda para conservarlos.
      </span>
      <button
        type="button"
        onClick={onDiscard}
        className="rounded-lg px-3 py-1.5 text-xs font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00C2FF]"
        style={{ backgroundColor: 'rgba(255,255,255,0.06)', color: '#E8EAF0' }}
      >
        Descartar cambios
      </button>
    </div>
  );
}
